/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/barutopia/"

const barutopia: CommunityData = {
  code: "barutopia",
  inviteCode: "barutopia",
  name: "Bar Utopia",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/uto-358`,
  socials: {},
  styles: {
    global: {
      werzLogoColor: "#363636",
      counterColor: "#363636",
      logo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[160px] h-[72.5px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[160px] h-[72.5px]",
      },
      modalWindow: {
        container: "!border-0 !bg-[#ffffff] !px-6 !py-8 sm:!px-6 sm:!py-8",
        title:
          "text-[#363636] font-['PlayfairDisplayBold'] text-[24px] leading-[110%] text-center normal-case tracking-normal",
        subtitle: "text-[#363636] font-['InterRegular'] text-[16px] leading-[120%] text-center",
        input: {
          container: "bg-[#ffffff]",
          input: "font-['InterRegular'] text-[#363636] placeholder:text-[#8d8d8d]",
        },
        amountInput: {
          container:
            "!w-[150px] !max-w-[150px] !h-auto !rounded-lg !border !border-[#363636] !bg-[#ffffff] !px-5 !py-3 !gap-4",
          input:
            "!text-[14px] !leading-[17px] font-['InterRegular'] !text-[#363636] !text-left !py-0",
          currency: "!pl-0 !text-[14px] !leading-[17px] font-['InterRegular'] !text-[#363636]",
          inputError: {
            container: "!border-[#d74545]",
            input: "!text-[#d74545]",
            currency: "!text-[#d74545]",
          },
          error:
            "max-w-[320px] text-center font-['InterRegular'] text-[12px] leading-[14.4px] text-[#d74545]",
        },
        button:
          "bg-[#d1a5f2] border border-[#000000] rounded-lg p-[18px] min-w-[90px] !text-[#000000] font-['PlayfairDisplayBold'] !text-[16px] text-center leading-[100%] normal-case tracking-normal",
      },
      bgColor: "#ffffff",
      asideBg: "#d1a5f2",
      asideStyles: "",
      contentBg: "#ffffff",
      contentBoxShadow: "",
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      mainFont: "font-['InterRegular']",
      primaryButton:
        "bg-[#d1a5f2] border border-[#363636] rounded-lg px-[18px] py-[18px] !text-[#000000] font-['PlayfairDisplayBold'] !text-[16px] text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#363636",
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      separator: "border-[#ebebeb]",
      item: "font-['PlayfairDisplayBold'] text-[16px] text-[#363636] text-left leading-[100%] gap-x-[10px] text-opacity-50 text-center !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#ffffff] !pb-8",
      titles: "text-[#363636] font-['PlayfairDisplayBold'] text-[26px] text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#8d8d8d] font-['InterRegular'] text-[14px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#ebebeb]",
        sectionTitle:
          "text-[#363636] font-['PlayfairDisplayBold'] text-[26px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#363636] font-['PlayfairDisplayBold'] text-[16px] text-left leading-[110%]",
          subtitle:
            "text-[#8d8d8d] font-['InterRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#ebebeb]",
        sectionTitle:
          "text-[#363636] font-['PlayfairDisplayBold'] text-[26px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent",
          title: "text-[#363636] font-['PlayfairDisplayBold'] text-[16px] text-left leading-[110%]",
          subtitle:
            "text-[#8d8d8d] font-['InterRegular'] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#8d8d8d] font-['InterRegular'] text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#8d8d8d] font-['InterRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#363636] font-['PlayfairDisplayBold'] text-[22px] text-left leading-[110%]",
        text: "text-[#363636] font-['InterRegular'] text-[16px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#363636] font-['PlayfairDisplayBold'] text-[26px] text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#ffffff] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#ebebeb]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title: "text-[#363636] font-['PlayfairDisplayBold'] text-[26px] text-left leading-[110%]",
        subtitle:
          "text-[#8d8d8d] font-['InterRegular'] text-[14px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#d1a5f2] border border-[#363636] rounded-lg px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#000000] font-['PlayfairDisplayBold'] !text-[16px] text-left leading-[100%]",
        questions: "text-[14px] text-left leading-[120%] text-[#8d8d8d]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#ebebeb]",
        header: "text-[#363636] font-['PlayfairDisplayBold'] text-[22px] text-left leading-[110%]",
        text: "text-[#363636] font-['InterRegular'] text-[14px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#ebebeb]",
        header: "text-[#363636] font-['PlayfairDisplayBold'] text-[22px] text-left leading-[110%]",
        text: "text-[#363636] font-['InterRegular'] text-[14px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden border border-[#ebebeb] gap-y-[10px] rounded",
        mapPinColor: "#363636",
        mapStrokeColor: "#ffffff00",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#363636] font-['PlayfairDisplayBold'] text-[22px] text-left leading-[110%]",
        text: "text-[#363636] font-['InterRegular'] text-[14px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#363636] font-['PlayfairDisplayBold'] text-[26px] text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-4 sm:mb-6 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#ffffff]",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#ffffff] border border-[#363636] rounded-lg px-4 py-4 text-[#000000] font-['PlayfairDisplayBold'] text-[14px] text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff] border-b border-[#ebebeb] py-2 sm:py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#363636] font-['PlayfairDisplayBold'] text-[16px] text-left leading-[110%] mb-1",
          description:
            "text-[#8d8d8d] font-['InterRegular'] text-[14px] text-left leading-[120%] mb-1 flex flex-row",
          price: "text-[#8d8d8d] font-['PlayfairDisplayBold'] text-[16px] text-left leading-[110%]",
          quantity:
            "text-[#000000] font-['PlayfairDisplayBold'] text-[14px] text-left leading-[100%]",
          status:
            "text-[#8d8d8d] font-['PlayfairDisplayBold'] text-[16px] text-left leading-[110%]",
          counterContainer:
            "bg-[#ffffff] border border-[#363636] rounded-lg px-4 py-4 gap-x-4 !w-fit !h-10",
          button:
            "bg-[#ffffff] border border-[#363636] rounded-lg px-4 py-4 text-[#000000] font-['PlayfairDisplayBold'] text-[14px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default barutopia
